import React, { useState, useEffect, useRef } from 'react';
import { Modal, Spinner } from 'react-bootstrap';

import FormSubmissionsTable from '../components/FormSubmissions/FormSubmissionsTable';
import LoadingWrapper from '../components/LoadingWrapper';
import ProjectDropdown from '../components/ProjectDropdown';

import DashboardService from '../services/DashboardService';

import IFormSubmission from '../types/Dashboard/FormSubmission';
import EmployeeInfo from '../types/Employee/EmployeeInfo';
import Project from '../types/Dashboard/Project';

type Props = {
    userData: EmployeeInfo;
    projects?: Project[];
//    updateProject?: (e: any) => void;
//    projectSelector: JSX.Element;
    cookieName: string;
//    selectedProject: string;
};

const Dashboard = ({
    userData,
    projects = [],
     //updateProject,
     //projectSelector,
     //selectedProject
     cookieName,
    }: Props) => {
    const mountedRef = useRef(true);

    useEffect(() => {
        mountedRef.current = true;
        return () => { mountedRef.current = false; };
    }, []);

    // State
    const [selectedProject, setSelectedProject] = useState<string | undefined>(undefined);

    const [formSubmissionsLoading, setFormSubmissionsLoading] = useState(false);
    const [formSubmissions, setFormSubmissions] = useState<IFormSubmission[]>([]);
    const [openFormStatusModal, setOpenFormStatusModal] = useState(false);
    const [taskUsersLoading, setTaskUsersLoading] = useState(false);
    const [taskUsers, setTaskUsers] = useState<string[]>([]);

    // Fetch form submissions (fetches all data for client-side filtering)
    const getFormSubmissions = async (projectID: string) => {
        try {
            const submissions = await DashboardService.getAllFormSubmissions(projectID);
            if (!mountedRef.current) return;
            setFormSubmissionsLoading(false);
            setFormSubmissions(submissions);
        } catch (e) {
            if (!mountedRef.current) return;
            setFormSubmissionsLoading(false);
        }
    };

    // Fetch task users for modal
    const getTaskUsers = async (entryID: string) => {
        try {
            const response = await DashboardService.getTaskUsers(entryID);
            if (!mountedRef.current) return;
            setTaskUsersLoading(false);
            setTaskUsers(response.data);
        } catch (e) {
            if (!mountedRef.current) return;
            setTaskUsersLoading(false);
        }
    };

    // Fetch form submissions when selectedProject changes
    useEffect(() => {
        if (!userData?.email || !selectedProject) {
            return;
        }

        setFormSubmissionsLoading(true);
        getFormSubmissions(selectedProject);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData?.email, selectedProject]);

    // Open form status modal
    const onFormStatusModal = (entryID: string) => {
        setOpenFormStatusModal(true);
        setTaskUsersLoading(true);
        getTaskUsers(entryID);
    };

    // Close form status modal
    const onCloseFormStatusModal = () => {
        setOpenFormStatusModal(false);
        setTaskUsers([]);
    };

    return (
        <div className='w-75'>
            <LoadingWrapper
                showLoading={!userData?.email}
                loadingMessage="Getting user data..."
                windSpinner
                windSpinnerScale={3}
            >
                <Modal show={openFormStatusModal} onHide={onCloseFormStatusModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Task Assigned To:</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group">
                            {taskUsersLoading ? (
                                <div className="DivPadded DivCenter">
                                    <Spinner animation="border" role="status" variant="primary" />
                                </div>
                            ) : (
                                <ul>
                                    {taskUsers.map((user, i) => (
                                        <li key={i}>{user}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </Modal.Body>
                </Modal>

                <ProjectDropdown
                  projects={projects}
                  cookieName={cookieName}
                  onProjectChange={(project) => {
                    setSelectedProject(project)
                  }}
                />

                <h1 className="header mt-5 mb-4 text-center">Form Submissions</h1>

                {selectedProject ? (
                    <div>
                        <div className="d-flex justify-content-end align-items-center mb-2">
                            <p className="mb-0"><i>Note: This data is refreshed every two hours from 6 AM to 6 PM CST</i></p>
                        </div>

                        <FormSubmissionsTable
                            formSubmissions={formSubmissions}
                            isLoading={formSubmissionsLoading}
                            onFormStatusClick={onFormStatusModal}
                        />
                    </div>
                ) : null}
            </LoadingWrapper>
        </div>
    );
};

export default Dashboard;
